import PanelTravel from '../PanelTravel/PanelTravel.vue'
import FormDetailsComission from '../FormDetailsComission/FormDetailsComission.vue'
export default {
  name: 'DetailsTravelComission',
  props: ['dataDetails'],
  components: {PanelTravel, FormDetailsComission},
  data () {
    return {
      tab: 0,
      Situacao: false,
      carregaTables: null,
      key: 0
    }
  },

  mounted () {
  },
  methods: {
    verificarItens () {
      let despesas = this.$refs.FormDetailsComission.dataExpense
      var verificar = despesas.find((Element) => Element.situacao === 0)
      if (verificar === null || verificar === undefined) {
        this.$refs.PanelTravel.flverificarItens = true
      } else {
        this.$refs.PanelTravel.flverificarItens = false
      }
    },
    reloadTable () {
      this.$refs.FormDetailsComission.onLoad()
      this.$refs.FormDetailsComission.GetLogById()
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/DetailsTravelComission/DetailsTravelComission.js